export default __webpack_public_path__ + "static/media/13.31d89217.jpg";